import { render } from "./NewContextMenu.vue?vue&type=template&id=35261804"
import script from "./NewContextMenu.vue?vue&type=script&lang=js"
export * from "./NewContextMenu.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__